import React, { useState } from 'react';
import { Modal } from 'react-bootstrap';
import ModalHeaderWithActions from './ModalHeaderWithActions';

interface MessageBoxProps {
    show: boolean;
    title: string;
    message: string;
    onClose: () => void;
}

const MessageBox: React.FC<MessageBoxProps> = ({
    show,
    title,
    message,
    onClose
}) => {
    return (
        <Modal show={show} onHide={onClose} backdrop="static" className="change-modal">
            <ModalHeaderWithActions
                title={title}
                onClose={onClose}
                onSubmit={() => { }}
                canSubmit={true}
                isInEditMode={false}
            />
            <Modal.Body>
                <p>{message}</p>
            </Modal.Body>
        </Modal>
    );
};

// Hook to use the confirm dialog
export const useMessageBox = () => {
    const [show, setShow] = useState(false);
    const [dialogConfig, setDialogConfig] = useState({
        title: '',
        message: ''
    });

    const showMessageBox = (title: string, message: string) => {
        setShow(true);
        setDialogConfig({ title, message });
    };

    const handleClose = () => {
        setShow(false);
    };

    const MessageBoxComponent = () => (
        <MessageBox
            show={show}
            title={dialogConfig.title}
            message={dialogConfig.message}
            onClose={handleClose}
        />
    );

    return { showMessageBox, MessageBoxComponent };
};

// Usage example:
// const { showMessageBox, MessageBoxComponent } = useMessageBox();
//
// const handleShow = async () => {
//   await showMessageBox('Hello', 'Thank you');
// };
//
// In your component's JSX:
// <MessageBoxComponent />
// <Button onClick={handleShow}>Show</Button>